import React, { ReactElement, useContext } from 'react'
import mapValues from 'lodash/mapValues'

import { FeatureFlagsContext } from '../context'
import { FeatureFlagName, FeatureFlags } from '../feature-flags'
import { getClientConfigBool } from '../config'

const flagValuesFromEnv = mapValues(FeatureFlagName, getClientConfigBool)

interface FfProps {
  children: ReactElement
  doGetFromEnv?: boolean
  overrides?: Partial<FeatureFlags>
}

export default function FeatureFlagsProvider({
  children,
  doGetFromEnv,
  overrides,
}: FfProps): ReactElement {
  const higherContext = useContext(FeatureFlagsContext)
  const baseValues = doGetFromEnv ? flagValuesFromEnv : higherContext
  const flagValues = Object.assign({}, baseValues, overrides)
  return (
    <FeatureFlagsContext.Provider value={flagValues}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
